import type { Audience } from "../engine";
import { t } from "./i18n";

export function renderWelcome(
  container: HTMLElement,
  onChoose: (audience: Audience) => void
): void {
  container.innerHTML = "";
  const wrapper = document.createElement("div");
  wrapper.className = "welcome";

  const logoDiv = document.createElement("div");
  logoDiv.className = "welcome-logo";
  const logoImg = document.createElement("img");
  logoImg.src = "/logo.png";
  logoImg.alt = "Big Bend Hospice";
  logoDiv.appendChild(logoImg);
  wrapper.appendChild(logoDiv);

  const heading = document.createElement("h1");
  heading.textContent = t("ui.welcome.title");
  wrapper.appendChild(heading);

  const description = document.createElement("p");
  description.className = "welcome-description";
  description.textContent = t("ui.welcome.description");
  wrapper.appendChild(description);

  const prompt = document.createElement("h2");
  prompt.className = "welcome-audience-prompt";
  prompt.textContent = t("ui.welcome.audience_prompt");
  wrapper.appendChild(prompt);

  const choices = document.createElement("div");
  choices.className = "audience-choices";
  const audiences: Audience[] = ["family", "professional"];
  audiences.forEach((audience) => {
    const card = document.createElement("button");
    card.type = "button";
    card.className = "audience-card";
    const label = document.createElement("span");
    label.className = "audience-label";
    label.textContent = t(`ui.welcome.audience.${audience}.label`);
    card.appendChild(label);
    const hint = document.createElement("span");
    hint.className = "audience-hint";
    hint.textContent = t(`ui.welcome.audience.${audience}.hint`);
    card.appendChild(hint);
    card.addEventListener("click", () => onChoose(audience));
    choices.appendChild(card);
  });
  wrapper.appendChild(choices);

  const note = document.createElement("p");
  note.className = "welcome-note";
  note.textContent = t("ui.welcome.privacy_note");
  wrapper.appendChild(note);

  container.appendChild(wrapper);
}
